import { Moon, Sun } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../lib/utils';
import { Tooltip } from '../ui/Tooltip';

export function ThemeToggle() {
  const { user, updateTheme } = useAuth();
  const isDark = user?.preferences.theme === 'dark';

  const toggleTheme = () => {
    updateTheme(isDark ? 'light' : 'dark');
  };

  return (
    <Tooltip content={`Switch to ${isDark ? 'light' : 'dark'} mode`} side="bottom">
      <button
        onClick={toggleTheme}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        className={cn(
          'flex items-center justify-center p-2 transition-colors',
          'hover:bg-gray-100 dark:hover:bg-gray-800'
        )}
      >
        {isDark ? (
          <Sun className="w-5 h-5 text-gray-700 dark:text-gray-300 pointer-events-none" />
        ) : (
          <Moon className="w-5 h-5 text-gray-700 dark:text-gray-300 pointer-events-none" />
        )}
      </button>
    </Tooltip>
  );
}




